import * as React from 'react';
import { People } from '@mui/icons-material';
import ReportLayout from '../Components/Reports/ReportLayout';

interface TypeReportProps {
  Entete: string;
  Type: string;
}

const ListClientFastReport: React.FC<TypeReportProps> = ({ Entete, Type }) => {
  return (
    <ReportLayout
      title={Entete}
      subtitle="Module Clients"
      icon={<People />}
      endpoint="module-clients"
      extraParams={{ Type }}
      showClientRange={true}
      showDateRange={true}
      showAgence={true}
      fileNamePrefix="rapport_clients"
    />
  );
};

export default ListClientFastReport;